import { initializeApp, getApps, getApp } from "firebase/app";

/**
 * Firebase Client Configuration
 * Sourced dynamically from environment variables per customer project.
 */
export const firebaseConfig = {
  apiKey: (typeof import.meta !== "undefined" && import.meta.env?.VITE_FIREBASE_API_KEY) || "AIzaSyMockKeyForDevEnvironmentPlaceholder",
  authDomain: (typeof import.meta !== "undefined" && import.meta.env?.VITE_FIREBASE_AUTH_DOMAIN) || "books-inventory-dev.firebaseapp.com",
  projectId: (typeof import.meta !== "undefined" && import.meta.env?.VITE_FIREBASE_PROJECT_ID) || "demo-books",
  storageBucket: (typeof import.meta !== "undefined" && import.meta.env?.VITE_FIREBASE_STORAGE_BUCKET) || "books-inventory-dev.firebasestorage.app",
  messagingSenderId: (typeof import.meta !== "undefined" && import.meta.env?.VITE_FIREBASE_MESSAGING_SENDER_ID) || "123456789012",
  appId: (typeof import.meta !== "undefined" && import.meta.env?.VITE_FIREBASE_APP_ID) || "1:123456789012:web:mockappid123456"
};

// Singleton initialization
export const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

export const isFirebaseConfigured = Boolean(
  typeof import.meta !== "undefined" &&
  import.meta.env?.VITE_FIREBASE_API_KEY && 
  import.meta.env?.VITE_FIREBASE_PROJECT_ID &&
  import.meta.env?.VITE_FIREBASE_API_KEY !== "AIzaSyMockKeyForDevEnvironmentPlaceholder"
);

export default app;
